import { io } from "socket.io-client";
import React from "react";
import { API_BASE_URL } from "../apiConfig";
const SOCKET_URL = API_BASE_URL;
export const socket = io(SOCKET_URL);
// app context
export const AppContext = React.createContext();
